import { nextFrame } from 'helpers/timing';
import useResetForm from 'stimulus-hooks/use-reset-form';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'subscriberRelationSelect',
    'subscriberFirstName',
    'subscriberFirstNameInput',
    'subscriberMiddleName',
    'subscriberLastName',
    'subscriberLastNameInput',
    'subscriberSuffix',
    'subscriberDateOfBirth',
    'subscriberDateOfBirthInput',
    'subscriberSex',
    'subscriberSexInput',
  ];

  connect() {
    useResetForm(this);
  }

  relationToSubscriberChanged(event) {
    const { target } = event.detail;
    const value = target.getAttribute('value');
    this.toggleSubscriberFieldVisibility(value);
  }

  async resetForm() {
    // Form reset is processed in the next animation frame.
    await nextFrame();
    if (this.relationIsSelf(this.subscriberRelationSelectTarget.value)) {
      this.hideSubscriberNameFields();
    }
  }

  /**
   * @private
   */
  toggleSubscriberFieldVisibility(value) {
    if (this.relationIsSelf(value)) {
      this.hideSubscriberNameFields();
    } else {
      this.showSubscriberNameFields();
    }
  }

  /**
   * @private
   */
  showSubscriberNameFields() {
    this.subscriberFirstNameTarget.hidden = false;
    this.subscriberFirstNameInputTarget.required = true;
    this.subscriberMiddleNameTarget.hidden = false;
    this.subscriberLastNameTarget.hidden = false;
    this.subscriberLastNameInputTarget.required = true;
    this.subscriberSuffixTarget.hidden = false;
    this.subscriberDateOfBirthTarget.hidden = false;
    this.subscriberSexTarget.hidden = false;
  }

  /**
   * @private
   */
  hideSubscriberNameFields() {
    this.subscriberFirstNameTarget.hidden = true;
    this.subscriberFirstNameInputTarget.required = false;
    this.subscriberMiddleNameTarget.hidden = true;
    this.subscriberLastNameTarget.hidden = true;
    this.subscriberLastNameInputTarget.required = false;
    this.subscriberSuffixTarget.hidden = true;
    this.subscriberDateOfBirthTarget.hidden = true;
    this.subscriberSexTarget.hidden = true;
  }

  /**
   * @private
   */
  relationIsSelf(value) {
    return value === 'self';
  }
}
